/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ connector: NonNullable<unknown> }} Agent_Templates_Needs_MissingInputs */



/**
* | output |
* | --- |
* | "{connector} (not connected)" |
*
* @param {Agent_Templates_Needs_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_templates_needs_missing = /** @type {((inputs: Agent_Templates_Needs_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Templates_Needs_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.connector} (nicht verbunden)`)
	return /** @type {LocalizedString} */ (`${i?.connector} (not connected)`)
});